import { formatHumanTimeDurationShort } from '@racemap/utilities/formatting';
import type { FC } from 'react';
import { TrackerTypeTag } from './TrackerTypeTag';

interface Props {
  paidUntil?: Date;
  width?: number;
}

export const ActiveUntilTag: FC<Props> = ({ paidUntil, width = 60 }) => {
  const remainingUseTime = paidUntil
    ? formatHumanTimeDurationShort(new Date(paidUntil).getTime() - Date.now())
    : '∞';
  return (
    <TrackerTypeTag
      color="blue"
      title="The device is used and remains active for a specific period of time. All features of tracker management are usable."
      width={width}
    >
      {remainingUseTime}
    </TrackerTypeTag>
  );
};
